import { REQUEST_TYPES } from '.';
export const uploadDocument = body => ({
    type: `[API] Upload Document`,
    url: '/uploadDocument',
    APIMethod: REQUEST_TYPES.POST,
    body,
});